import "../scss/styles.scss";

import { AnimatedCardList } from "./animatedCardList";
import { ClickableCard } from "./clickableCard";
import { EveryActionForm } from "./everyActionForm";
import { Megamenu } from "./megamenu";
import { ShareButtons } from "./shareButtons";
import { StickySecondaryNav } from "./stickySecondaryNav";

class App {

    public run(): void {
        AnimatedCardList.attach(AnimatedCardList, AnimatedCardList.selector);
        ClickableCard.attach(ClickableCard, ClickableCard.selector);
        EveryActionForm.attach(EveryActionForm, EveryActionForm.selector);
        Megamenu.attach(Megamenu, Megamenu.selector);
        ShareButtons.attach(ShareButtons, ShareButtons.selector);
        StickySecondaryNav.attach(StickySecondaryNav, StickySecondaryNav.selector);
    }
}

window.onload = () => {
    const app = new App();
    app.run();
}

export { App };
